import { t } from '@lingui/core/macro';
import { Box, Chip, TableBodyCell, TableCellEmpty, Typography, UserAvatar } from '@pocketlaw/tetris';
import { useFileBrowserContext } from 'app/domains/filesystem';
import { EntryKind } from 'shared/domains/apollo/generated/types';
import { TypeAvatarWithLabel } from 'shared/domains/common-ui';
import { localizedFormatDate } from 'shared/domains/common-utils';
import { StyledButton, StyledTableRow } from './styled';
export function Row(props) {
    const { entry, multiselect } = props;
    const { id, kind, name, updatedAt, owner, disabled: entryDisabled } = entry;
    const { selfId, selected, onSelect } = useFileBrowserContext();
    const handleSelect = () => onSelect(entry);
    // We pass this empty function to `TypeAvatarWithLabel` because we want it to render
    // a checkbox but we don't want it to be clickable. If we pass a callback that
    // updates the selected state it runs twice and nothing happens.
    const nOop = () => { };
    const disabled = entryDisabled || selfId === id;
    const checked = selected === null || selected === void 0 ? void 0 : selected.some((selectedEntry) => selectedEntry.id === id);
    const creatorName = (owner === null || owner === void 0 ? void 0 : owner.name) || '';
    const localizedUpdatedAt = localizedFormatDate(updatedAt, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
    });
    const updatedAtElement = (<Typography $fontSize="small" $appearance="300">
      {localizedUpdatedAt}
    </Typography>);
    if (kind === EntryKind.Folder) {
        return (<StyledTableRow $hoverCursor onClick={handleSelect} $disabled={disabled}>
        <TableBodyCell headers="cell:name">
          <StyledButton type="button" onClick={handleSelect}>
            <TypeAvatarWithLabel size="sm" title={name} type="folder" truncate selected={checked}/>
          </StyledButton>
        </TableBodyCell>
        <TableBodyCell headers="cell:updated">{updatedAtElement}</TableBodyCell>
        <TableBodyCell headers="cell:owner">
          <TableCellEmpty />
        </TableBodyCell>
      </StyledTableRow>);
    }
    return (<StyledTableRow $hoverCursor $selected={checked} $disabled={disabled} onClick={handleSelect}>
      <TableBodyCell headers="cell:name">
        <Box alignItems="center" gap="md">
          <TypeAvatarWithLabel truncate size="sm" multiselect={multiselect} title={name} type="file" selected={checked} onSelect={nOop}/>
          {selfId === id && (<Chip size="small" appearance="primary" label={t({ comment: 'Current document label', message: 'Current document' })}/>)}
        </Box>
      </TableBodyCell>
      <TableBodyCell headers="cell:updated">{updatedAtElement}</TableBodyCell>
      <TableBodyCell headers="cell:creator">
        <UserAvatar title={creatorName} size="sm"/>
      </TableBodyCell>
    </StyledTableRow>);
}
